import {Component, forwardRef, Injector, Input} from "@angular/core";
import {ColumnComponent} from "../../framework/entity/grid/column.component";
import {AbstractSingleSelectColumnComponent} from "../../framework/entity/edit/edit-grid/columns/abstract-single-select-column.component";

@Component({
    selector: "wbo-day-of-week-single-select-column",
    templateUrl: "../../framework/entity/edit/edit-grid/columns/single-select-column.component.html",
    providers: [
        {
            provide: ColumnComponent,
            useExisting: forwardRef(() => DayOfWeekSingleSelectColumnComponent),
            multi: true
        }
    ]
})
export class DayOfWeekSingleSelectColumnComponent extends AbstractSingleSelectColumnComponent {
    @Input() membershipTypeField: string;

    constructor(injector: Injector) {
        super(injector);

        this.buildData([
            {label: "wbo.common.dayOfWeek.monday", value: "monday"},
            {label: "wbo.common.dayOfWeek.tuesday", value: "tuesday"},
            {label: "wbo.common.dayOfWeek.wednesday", value: "wednesday"},
            {label: "wbo.common.dayOfWeek.thursday", value: "thursday"},
            {label: "wbo.common.dayOfWeek.friday", value: "friday"},
            {label: "wbo.common.dayOfWeek.saturday", value: "saturday"},
            {label: "wbo.common.dayOfWeek.sunday", value: "sunday"}
        ]);
    }
}
